// home
export const UPDATE_QRCODE_URL = 'UPDATE_QRCODE_URL'
export const UPDATE_VERSION = 'UPDATE_VERSION'
export const WS_DISCONNNECT = 'WS_DISCONNNECT'
export const UPDATE_BUNDLES = 'UPDATE_BUNDLES'
// weex
export const UPDATE_REMOTE_DEBUG_STATUS = 'UPDATE_REMOTE_DEBUG_STATUS'
export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS'
export const UPDATE_ELEMENT_MODE_STATUS = 'UPDATE_ELEMENT_MODE_STATUS'
export const UPDATE_LOG_LEVEL_STATUS = 'UPDATE_LOG_LEVEL_STATUS'
export const UPDATE_INSTANCE_URL = 'UPDATE_INSTANCE_URL'
export const CLEAN_INSTANCE_HISTORY = 'CLEAN_INSTANCE_HISTORY'
export const UPDATE_WEEX_ENVIRONMENT = 'UPDATE_WEEX_ENVIRONMENT'
export const CLEAN_WEEX_ENVIRONMENT = 'CLEAN_WEEX_ENVIRONMENT'
// analyze
export const UPDATE_ANALYZE_DEFAULT_HISTORY = 'UPDATE_ANALYZE_DEFAULT_HISTORY'
export const UPDATE_ANALYZE_DEFAULT_CAPTURE = 'UPDATE_ANALYZE_DEFAULT_CAPTURE'
export const UPDATE_ANALYZE_HISTORYS = 'UPDATE_ANALYZE_HISTORYS'
export const UPDATE_ANALYZE_CAPTURES = 'UPDATE_ANALYZE_CAPTURES'
export const UPDATE_ANALYZE_TOGGLE = 'UPDATE_ANALYZE_TOGGLE'
export const UPDATE_ANALYZE_APMDATA = 'UPDATE_ANALYZE_APMDATA'

// global
export const UPDATE_CHANNEL_ID = 'UPDATE_CHANNEL_ID'
export const UPDATE_ENVIRONMENT_SETTING = 'UPDATE_ENVIRONMENT_SETTING'
export const UPDATE_HELP_SETTING = 'UPDATE_HELP_SETTING'
export const UPDATE_BUNDLE_SETTING = 'UPDATE_BUNDLE_SETTING'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/mutation-types.ts